import React from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import CircularProgress from 'material-ui/CircularProgress';
import MediaMetaInfo from './MediaMetaInfo';
import { modalStyle } from './modal-style';
import modernEnvironment from '../../lib/RelayUtils';

class PopupMeta extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
        };
    }

    closeModal(state) {
        this.setState({
            open: state.open,
        });
        this.props.closeDialogHandle();
    }

    render() {
        const query = graphql`
            query PopupMeta_item_Query($id: ID!){
                node(id: $id) {
                    ...on MediaFile {
                        id
                        title
                        slug
                        description
                        filename
                        alt
                        type
                        preview
                        authors
                        show
                        topics{
                            id
                            name
                        }
                        status
                        seoKeywords
                        seoDescription
                        seoTitle
                        state
                    }
                },
                viewer {
                    ...TopicSelector_viewer
                }
            }
        `;
        return (<QueryRenderer
            environment={modernEnvironment}
            query={query}
            variables={{ id: this.props.id }}
            render={({ error, props }) => {
                if (error) {
                    return (<div>{error.message}</div>);
                }
                if (props) {
                    const sendData = {
                        viewer: {
                            __fragments: props.viewer.__fragments,
                            __id: props.viewer.__id,
                        },
                    };
                    return (
                        <MediaMetaInfo
                            open={this.state.open}
                            viewer={sendData}
                            originalName=''
                            type={props.node.type}
                            sendMediaState={() => {
                            }}
                            setInfo={props.node}
                            getOpenState={(state) => {
                                this.closeModal(state);
                            }}
                        />
                    );
                } else {
                    return (
                        <Dialog
                            open={this.state.open}
                            modal={false}
                            contentStyle={{
                                ...modalStyle.main,
                                width: 865,
                                maxWidth: 865,
                            }}
                            bodyStyle={{
                                ...modalStyle.body,
                                borderTop: 'none',
                                borderBottom: 'none',
                                padding: '0 31px 30px',
                            }}
                            overlayStyle={modalStyle.overlay}
                            onRequestClose={() => { this.props.closeDialogHandle() }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 9,
                                }}
                            >
                                <IconButton
                                    onClick={() => { this.props.closeDialogHandle() }}
                                >
                                    <CloseIcon hoverColor="#542376"/>
                                </IconButton>
                            </div>
                            <div className="loader-wrapper">
                                <CircularProgress size={80} thickness={7}/>
                            </div>
                        </Dialog>
                    );
                }
            }}
        />);
    }
};

export default PopupMeta;



// WEBPACK FOOTER //
// src/components/media/PopupMeta.js